<template>
  <div>
    <!-- *********************************打印 start ********************************* -->
    <!-- 选择打印模板 -->
    <printDialog
      :dialogFrom="dialogFrom"
      ref="dialogSelect"
      title="选择模板"
      icon="el-icon-printer"
      :modelTypeVal="modelTypeVal"
      :modelClassName="modelClassNameSelf"
      @handleCreated="handleCreated"
      @handleView="handleView"
      @handleEdit="handleEdit"
      @handleOk="handleView"
      :edit-permission="hasEditPermission"
      :del-permission="hasDelPermission"
      :add-permission="hasAddPermission"
      :view-permission="selectTableData && selectTableData.length > 0"
      :printClassName = "printClassName"
      :conditonKey = "conditonKey"
      :printId="printId"
    ></printDialog>

    <!-- 创建和使用模板 -->
    <printSys
      :printForm="printForm"
      :title="printTitle"
      icon="el-icon-printer"
      @handleClose="handlePrintSysClose"
    >
      <printSysContent
        :printType="printType"
        :modelObj="modelObj"
        :modelClassName="modelClassName"
        :getApiType="getApiType"
        :selectTableData="selectTableData"
        :apiNumber="apiNumber"
        :conditions="conditionVal"
        :dataSource="dataSource"
        :edit-permission="hasEditPermission"
      ></printSysContent>
    </printSys>

    <!-- 打印系统数据接口的className -->
    <classNameDialog
      :diaWidth="classNameDiaWidth"
      :dialogTitle="classNameDialogTitle"
      :isShowDialog="isShowClassNameDialog"
      @handleCloseDia="handleCloseClassNameDia"
      @diaCancelBtn="classNameDiaCancelBtn"
      @diaConfirmBtn="classNameDiaConfirmBtn"
    >
      <el-select
        v-model="modelClassNameSelf"
        placeholder
        style="width: 100%"
        @change="changeModelClass"
      >
        <el-option
          v-for="(value, key) in classNameArr"
          :key="key"
          :label="value.name"
          :value="value.val"
        ></el-option>
      </el-select>
    </classNameDialog>
  </div>
</template>

<script>
import prints from "@/components/prints/print_waiFa.vue";
import printDialog from "@/components/printDialog/index.vue";
import printSys from "@/components/printSys/index.vue";
import printSysContent from "@/components/printSys/content.vue";
import classNameDialog from "@/components/Dialog.vue";
import { hiprint } from "@/print.js";
import { type } from "os";
export default {
  components: {
    prints,
    printDialog,
    printSys,
    printSysContent,
    classNameDialog,
  },
  props: {
    modelTypeVal: {},
    classNameArr: {},
    modelClassName: {},
    getApiType: {
      type: Boolean,
      default: false,
    },
    printId: {
      type: [Array,Number],
      default: null,
    },
    apiNumber: {
      require: false,
      default: null,
    },
    printClassName: {
      require: false,
      default: null,
    },
    conditonKey: {
      require: false,
      default: null,
    },
    conditions: {
      require: false,
      default() {
        return {};
      },
    },
    dataSource: {
      require: false,
      default: null,
    },
    addPermission: {
      Type: Object,
      require: false,
      default() {
        return "print:update";
      },
    },
    editPermission: {
      Type: Object,
      require: false,
      default() {
        return "print:update";
      },
    },
    delPermission: {
      Type: Object,
      require: false,
      default() {
        return "print:update";
      },
    },
  },
  data() {
    return {
      // 打印模块
      // 打印预览
      classNameDiaWidth: "300px",
      classNameDialogTitle: "请选择打印模板类型",
      isShowClassNameDialog: false,

      isShowDialog_print: false,
      diaWidth_print: "90%",
      dialogTitle_print: "打印预览",
      dataList: [],
      topData: {},
      modelClassNameSelf: this.modelClassName,
      conditionVal: {},
      // 打印弹出框
      dialogFrom: {
        dialogVisible: false,
      },
      // 创建新的打印
      printForm: {
        dialogVisible: false,
        conditions: {},
      },
      printTitle: "创建模板",
      printType: 1, // 1是创建 2是使用
      // 打印
      printDesignForm: {
        dialogVisible: false,
      },
      // 选择的模板数据
      modelObj: null,
      selectTableData: [],
      hasAddPermission: this.hasAddPermissions(),
      hasEditPermission: this.hasEditPermissions(),
      hasDelPermission: this.hasDelPermissions(),
    };
  },
  watch: {
    modelClassName: {
      handler(val) {
        this.modelClassNameSelf = val;
        this.hasAddPermission = this.hasAddPermissions();
        this.hasEditPermission = this.hasEditPermissions();
        this.hasDelPermission = this.hasDelPermissions();
      },
      // printClassName:{
      //   handler(val) {
      //     console.info('conditonKey',this.conditonKey)
      //     console.info('printClassName',this.printClassName)
      //   }
      // },

    },
  },
  computed: {},
  methods: {
    hasAddPermissions() {
      let permission = this.addPermission;
      if (this.addPermission instanceof Function) {
        permission = this.addPermission("add");
      }
      return permission;
    },
    hasEditPermissions() {
      let permission = this.editPermission;
      if (this.editPermission instanceof Function) {
        permission = this.editPermission("edit");
      }
      return permission;
    },
    hasDelPermissions() {
      let permission = this.delPermission;
      if (this.editPermission instanceof Function) {
        permission = this.delPermission("del");
      }
      return permission;
    },
    // *************************打印模板 start *************************
    handleCloseClassNameDia() {
      this.isShowClassNameDialog = false;
    },
    classNameDiaCancelBtn() {
      this.isShowClassNameDialog = false;
    },
    classNameDiaConfirmBtn() {
      // modelClassName
      if (!this.modelClassName) {
        this.$message.error("请选择className");
        return;
      }
      this.isShowClassNameDialog = false;
      setTimeout(() => {
        this.dialogFrom.dialogVisible = false;
        this.printTitle = "创建模板";
        this.printType = 1;
        this.modelObj = null;
        setTimeout(() => {
          this.printForm.dialogVisible = true;
        }, 300);
      }, 300);
    },
    // 打印系统关闭
    handlePrintSysClose() {
      if (this.$refs.dialogSelect) {
        this.$refs.dialogSelect.doSearch();
      }
    },
    // 打印弹出框创建
    handleCreated() {
      this.dialogFrom.dialogVisible = false;
      // this.isShowClassNameDialog = true;
      let obj2 = {
        modelClassName: this.modelClassName,
        className: this.printClassName,
        id: this.printId,
        conditonKey: this.conditonKey,
        modelId: '',
        modelName: '',
      };
      // sessionStorage.setItem("printModelContent", obj.content);
      this.$router.push({ path: "/systemSettings/printSetting", query: obj2 });
    },

    // 打印预览模板
    handleEdit(obj) {
      this.dialogFrom.dialogVisible = false;
      this.printTitle = obj.modelName;
      this.printType = 2;
      this.modelObj = obj;
      if (this.conditions instanceof Function) {
        this.conditionVal = this.conditions(this.selectTableData);
      } else {
        this.conditionVal = this.conditions;
      }
      console.info("打印预览模板", this.printId);
      // setTimeout(() => {
      //   this.printForm.dialogVisible = true;
      // }, 300);
      // this.dialogFrom.dialogVisible = false;
      let obj2 = {
        modelClassName: this.modelClassName,
        className: this.printClassName,
        id: this.printId,
        conditonKey: this.conditonKey,
        modelId: obj.modelId,
        modelName: obj.modelName,
      };
      sessionStorage.setItem("printModelContent", obj.content);
      this.$router.push({ path: "/systemSettings/printSetting", query: obj2 });
    },
    // 打印预览模板
    handleView(obj) {
      hiprint.init();
      let hiprintTemplate = new hiprint.PrintTemplate({
        template: JSON.parse(obj.content),
        settingContainer: '#PrintElementOptionSetting'
      });
      if (this.apiNumber) {
        this.$API
            .runList({
              number: this.apiNumber,
              ...this.conditions,
            })
            .then((res) => {
              this.ajaxData = res[0];
              console.info("打印数据", this.ajaxData)
              // 修改此处以支持分页打印
              if (Array.isArray(this.ajaxData)) {
                // 如果是数组，使用print方法并启用分页
                hiprintTemplate.print(this.ajaxData, {
                  pageBreak: true // 启用分页
                });
              } else {
                // 如果不是数组，直接打印
                hiprintTemplate.print(this.ajaxData, {});
              }
              //console.log(hiprintTemplate)
              //hiprintTemplate.print2(this.ajaxData, {printer:'打印机名称',title:'打印任务名称'});
              //this.$print2(JSON.parse(obj.content),this.ajaxData,{printer:'打印机名称',title:'打印任务名称'})
            })
            .catch((err) => {});
        return;
      }
      if (this.dataSource) {
        this.dataSource(this.selectTableData, this.modelClassName)
            .then((res) => {
              let datas = res || [];
              let i = 1;
              datas.forEach((item) => {
                // item.modelClassName = this.modelClassName;
                if (item.billInfos && item.billInfos.length > 0) {
                  item.billInfos.forEach((itemA, idxA) => {
                    //后端返回的排序会乱,前端自己排序赋值
                    itemA.serialNumber = idxA + 1;
                  });
                }
                item.labelIndex = i++;
              });
              this.ajaxData = datas;
              console.info("打印数据2", this.ajaxData)
              // 修改此处以支持分页打印
              if (Array.isArray(this.ajaxData)) {
                // 如果是数组，使用print方法并启用分页
                hiprintTemplate.print(this.ajaxData, {
                  pageBreak: true // 启用分页
                });
              } else {
                // 如果不是数组，直接打印
                hiprintTemplate.print(this.ajaxData, {});
              }
              //console.log(hiprintTemplate.getPrinterList())
              //hiprintTemplate.print2(this.ajaxData, {printer:'',title:'打印任务名称'});
            })
            .catch((err) => {});
        return;
      }
    },

    handleViewNow(printer,obj) {
      hiprint.init();
      const json = JSON.parse(obj.content)
      const pannel = json.panels[0]
      let options = {
        printer,
        title: "打印",
        landscape: pannel.orient == 2
      }
      let hiprintTemplate = new hiprint.PrintTemplate({
        template: json,
      });
      if (this.apiNumber) {
        this.$API
            .runList({
              number: this.apiNumber,
              ...this.conditions,
            })
            .then((res) => {
              this.ajaxData = res[0];
              // 添加分页支持
              if (Array.isArray(this.ajaxData)) {
                hiprintTemplate.print2(this.ajaxData, {...options, pageBreak: true});
              } else {
                hiprintTemplate.print2(this.ajaxData, options);
              }
            })
            .catch((err) => {});
        return;
      }
      if (this.dataSource) {
        this.dataSource(this.selectTableData, this.modelClassName)
            .then((res) => {
              console.log("打印数据res", res);
              let datas = res || [];
              datas.forEach((item) => {
                // item.modelClassName = this.modelClassName;
                if (item.waybillInfos && item.waybillInfos.length > 0) {
                  item.waybillInfos.forEach((itemA, idxA) => {
                    //后端返回的排序会乱,前端自己排序赋值
                    itemA.serialNumber = idxA + 1;
                  });
                }
              });
              this.ajaxData = datas;
              // 添加分页支持
              if (Array.isArray(this.ajaxData)) {
                hiprintTemplate.print2(this.ajaxData, {...options, pageBreak: true});
              } else {
                hiprintTemplate.print2(this.ajaxData, options);
              }
            })
            .catch((err) => {});
        return;
      }
    },

    printSetting() {
      
      this.dialogFrom.dialogVisible = true;
    },

    // 打印
    printEvent(rows,setting) {
      if (rows.length < 1) {
        if (!this.hasPermiss(this.hasAddPermissions())) {
          this.$message.warning("请选择需要打印的记录");
          return;
        }
        this.$confirm("还没有选择需要打印的数据源,是否新建模板?", "提示:", {
          confirmButtonText: "新建模板",
          cancelButtonText: "关闭",
        }).then((res) => {
          if (res == "confirm") {
            this.handleCreated();
          } else {
            // this.$message.error("请选择需要打印的数据源");
            // return false;
          }
        });
      } else {
        if(!setting){
          let printer = localStorage.getItem(this.modelClassName + ':printer')
          let template = localStorage.getItem(this.modelClassName + ':template')
          // 没设置默认打印机的走常规流程
          if(printer && template){
            return this.printEventNow(rows);
          }
        }
        this.selectTableData = rows;
        this.dialogFrom.dialogVisible = true;
      }
    },

    // 直接打印
    printEventNow(rows) {
      let printer = localStorage.getItem(this.modelClassName + ':printer')
      let template = localStorage.getItem(this.modelClassName + ':template')
      // 没设置默认打印机的走常规流程
      if(!printer || !template){
        this.$message.warning("尚未设置默认打印");
        return this.printEvent(rows);
      }
      template = JSON.parse(template)
      if (rows.length < 1) {
        if (!this.hasPermiss(this.hasAddPermissions())) {
          this.$message.warning("请选择需要打印的记录");
          return;
        }
        this.$confirm("还没有选择需要打印的数据源,是否新建模板?", "提示:", {
          confirmButtonText: "新建模板",
          cancelButtonText: "关闭",
        }).then((res) => {
          if (res == "confirm") {
            this.handleCreated();
          } else {
            // this.$message.error("请选择需要打印的数据源");
            // return false;
          }
        });
      } else {
        this.selectTableData = rows;
        // todo 取出本地缓存的模板
        hiprint.init();
        let hiprintTemplate = new hiprint.PrintTemplate({
          template: JSON.parse(template.content),
        });
        this.handleViewNow(printer,template)
      }
    },
    changeModelClass(val) {
      this.$emit("update:modelClassName", val);
      this.hasAddPermission = this.hasAddPermissions();
      this.hasEditPermission = this.hasEditPermissions();
      this.hasDelPermission = this.hasDelPermissions();
    },
  },
};
</script>

<style>
</style>